import { resolveSuborigen } from "./utmTracker";
import { UTM_DEFAULT_MEDIUM, UTM_DEFAULT_SOURCE } from "../config/whatsappConfig";

/** `origin_id` en el OpenAPI de Tecnóm es numérico; solo lo enviamos si `utm_term` es un entero. */
const parseOriginIdFromUtmTerm = (term) => {
  if (term == null) return undefined;
  const s = String(term).trim();
  if (!s || !/^\d+$/.test(s)) return undefined;
  const n = Number(s);
  return Number.isSafeInteger(n) ? n : undefined;
};

// Función para mapear datos del formulario al formato de Tecnóm

export const mapFormDataToTecnom = (formData) => {
  const currentDate = new Date().toISOString();

  // Mapear el tipo de operación según la selección del usuario
  const operationType =
    formData.tipoPlan === "plan"
      ? "Plan de Ahorro"
      : formData.tipoPlan === "venta directa" || formData.tipoPlan === "directa"
      ? "Venta Directa"
      : formData.tipoPlan || "Consulta";

  const origin = formData.utm_source || UTM_DEFAULT_SOURCE;

  const hadPrincipalUtms = Boolean(formData.had_principal_utms);
  const suborigen = resolveSuborigen(
    hadPrincipalUtms ? { utm_medium: formData.utm_medium } : { utm_medium: "" },
    formData.contact_entry
  );

  const medioStr = formData.medio != null ? String(formData.medio).trim() : "";
  const mediumApi = (medioStr !== "" ? medioStr : null) || formData.utm_medium || UTM_DEFAULT_MEDIUM;

  // Campaign: solo utm_campaign de la URL (vacío si no hay)
  const campaign = formData.utm_campaign || "";

  // Limpiar el teléfono (remover espacios)
  const cleanPhone = formData.phone ? formData.phone.replace(/\s+/g, "") : "";

  // Construir la descripción del vehículo para comments
  let vehicleDescription = "";
  if (formData.vehicle) {
    vehicleDescription = formData.vehicle;
  } else if (formData.vModelo) {
    vehicleDescription = `${formData.brand || ""} ${formData.vModelo}`.trim();
    if (formData.vVersion) {
      vehicleDescription += ` ${formData.vVersion}`;
    }
  }

  // UTM en comments (mismo formato que el otro site)
  const utmComment = [
    formData.utm_source && `utm_source: ${formData.utm_source}`,
    formData.utm_medium && `utm_medium: ${formData.utm_medium}`,
    formData.utm_campaign && `utm_campaign: ${formData.utm_campaign}`,
    formData.utm_content && `utm_content: ${formData.utm_content}`,
    formData.utm_term && `utm_term: ${formData.utm_term}`,
  ]
    .filter(Boolean)
    .join(" | ");

  // Tracking adicional en comments (gclid va en el campo `ad` del payload)
  const extraTracking = ["gad_source", "gad_campaignid"]
    .filter((k) => formData[k])
    .map((k) => `${k}=${formData[k]}`)
    .join(" ");

  // product = auto seleccionado si hay; si no, marca por defecto
  const product =
    (vehicleDescription && String(vehicleDescription).trim()) || formData.brand || "FIAT";

  const utmTermStr = formData.utm_term != null ? String(formData.utm_term).trim() : "";
  const originId = parseOriginIdFromUtmTerm(formData.utm_term);

  // Construir el objeto vehicle solo si tenemos datos de identificación válidos
  // La API requiere al menos registration_plate o vin_vis
  let vehicle = null;

  // Si tenemos patente o VIN, construimos el objeto vehicle
  if (formData.registration_plate || formData.vin_vis) {
    vehicle = {
      ...(formData.registration_plate && {
        registration_plate: {
          value: formData.registration_plate,
        },
      }),
      ...(formData.vin_vis && {
        vin_vis: {
          value: formData.vin_vis,
        },
      }),
      ...(vehicleDescription && { description: vehicleDescription }),
      ...(formData.model_make_code && { model_make_code: formData.model_make_code }),
      ...(formData.year && { year: formData.year }),
    };
  }

  return {
    contact: {
      full_name: formData.name || "",
      email: {
        value: formData.email || "",
        type: "work",
      },
      phone: {
        value: cleanPhone,
        type: "work",
        country_code: "AR",
      },
      mobile_phone: {
        value: cleanPhone,
        type: "work",
        country_code: "AR",
      },
    },
    product,
    comments: [formData.comments, `Tipo de operación: ${operationType}`, vehicleDescription && `Vehículo: ${vehicleDescription}`, utmComment, extraTracking]
      .filter(Boolean)
      .join(" - "),
    medium: mediumApi,
    sub_origin: suborigen,
    origin,
    campaign,
    requested_at: currentDate,
    first_contacted_at: currentDate,
    ...(originId !== undefined ? { origin_id: originId } : {}),
    ...(utmTermStr !== "" ? { source_form_id: utmTermStr.slice(0, 500) } : {}),
    ...(formData.page_url && /^https?:\/\//i.test(String(formData.page_url).trim())
      ? { details_external_link: String(formData.page_url).trim().slice(0, 2000) }
      : {}),
    ...(formData.gclid ? { ad: formData.gclid } : {}),
    ...(vehicle && { vehicle }),
  };
};

